module.exports = __webpack_public_path__ + "0ec0b0f8a4fb5492ef3d8a5458a9d7ab.svg";